<template>
  <v-container fill-height fluid>
    <v-layout row wrap>
      <v-flex xs12>
        <v-layout row wrap>
          <v-spacer></v-spacer>
          <v-flex md4 sm8 xs12>
            <v-card class="elevation-0 bordered-card">
              <v-card-title>
                <div class="title">{{ $t('labels.supportTitle') }}</div>
              </v-card-title>
              <v-card-text>
                <div>{{ $t('labels.supportText') }}</div>
                <v-text-field
                  :label="$t('fields.name_and_surname') + '*'"
                  :type="'text'"
                  class="mt-5"
                  outline
                  v-model="supportData.name"
                ></v-text-field>
                <v-text-field
                  :label="$t('fields.email') + '*'"
                  :type="'text'"
                  outline
                  v-model="supportData.email"
                ></v-text-field>
                <v-text-field
                  :hint="$t('labels.mobileHint')"
                  :label="$t('fields.phone') + '*'"
                  :type="'text'"
                  outline
                  v-model="supportData.phone"
                ></v-text-field>
                <v-text-field
                  :label="$t('fields.subject') + '*'"
                  :type="'text'"
                  outline
                  v-model="supportData.subject"
                ></v-text-field>
                <v-textarea
                  :label="$t('fields.message') + '*'"
                  outline
                  v-model="supportData.message"
                ></v-textarea>
                <v-flex xs12>
                  <label>{{ $t('labels.attachmentPhoto') }}:</label>
                  <Upload
                    :accept="'image/png, image/jpeg'"
                    v-model="supportData.attachment"
                  />
                </v-flex>
              </v-card-text>
              <v-card-actions>
                <v-btn @click="sendClick()" color="primary">{{
                  $t('buttons.send')
                }}</v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>
          <v-spacer></v-spacer>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import handle_session_error from '@/helpers/handle_session_error.js'
import Upload from '@/components/trinkets/Upload.vue'

export default {
  name: 'Support',
  components: {
    Upload,
  },
  data() {
    return {
      supportData: {
        name: '',
        email: '',
        phone: '',
        subject: '',
        message: '',
        attachment: {
          name: '',
          original_name: '',
          link: '',
        },
      },
    }
  },
  watch: {},
  methods: {
    sendClick() {
      let message = ''
      if (this.supportData.name == '') {
        message += this.$t('alerts.nameSurnameMissing') + '<br />'
      }
      if (this.supportData.email == '') {
        message += this.$t('alerts.emailMissing') + '<br />'
      } else {
        if (!this.$checkEmail(this.supportData.email)) {
          message += this.$t('alerts.emailVerification') + '<br />'
        }
      }
      if (this.supportData.phone == '') {
        message += this.$t('alerts.phoneMissing') + '<br />'
      } else {
        if (
          !this.supportData.phone.match(/^\+385\d{8,9}$/) &&
          !this.supportData.phone.match(/^0\d{8,9}$/)
        ) {
          message += this.$t('alerts.phoneFailFormat') + '<br />'
        }
      }
      if (this.supportData.subject == '') {
        message += this.$t('alerts.subjectMissing') + '<br />'
      }
      if (this.supportData.message == '') {
        message += this.$t('alerts.messageMissing') + '<br />'
      }
      if (message == '') {
        let vm = this
        this.$APICall(
          'post',
          'SUPPORT',
          '',
          this.supportData,
          function () {
            vm.$alert(vm.$t('alerts.supportSuccess'))
            vm.$router.push('/events')
          },
          true,
          error => {
            handle_session_error(error, this.$store, this.$router, this.$prompt)
          }
        )
      } else {
        this.$alert(message)
      }
    },
  },
  mounted() {},
}
</script>

<style scoped>
.bordered-card {
  border: 2px solid #e8e8e8 !important;
}
</style>
